<template>
  <div class="con">
    <div class="content">
      <div class="title">Loan Limit Contract</div>
      <div class="list">
        In order to protect your legitimate rights and interests, you should
        read and abide by the loan limit contract (hereinafter referred to as
        this contract). You must carefully read and fully understand the content
        of each clause, especially the clauses for exemption or limitation of
        liability. Limitation and exemption clauses may be colored in black or
        bolded form reminds you to pay attention.
      </div>
      <div class="list">
        Unless you have read and accepted all the terms of this contract, you
        have no right to use the loan service. Your use, login, etc. are deemed
        to be that you have read and agreed to be bound by this contract, and
        this contract is effective immediately.
      </div>
      <div class="list">
        This contract is signed by you and the lender.
      </div>
    </div>
    <div class="content">
      <div class="title">Article I Definition</div>
      <div class="list">
        1. Available credit line: refers to the maximum amount that you are
        entitled to apply from the Lender at the designated period indicated.
      </div>
      <div class="list">
        2. Usable limit =the sum of the principal amount of a single loan that
        has been applied for and issued to the Borrower, and has yet to be
        utilized
      </div>
      <div class="list">
        3. Withdrawal Application (cancellation of Loan Application): The
        Borrower may cancel any loan application made to the Lender, before the
        disbursement of such Loan to the Borrower – without any cost to the
        Borrower.
      </div>
      <div class="list">
        Alternatively, the Lender through its loan personnel officer, retained
        and acting on behalf of the Lender, has the right to adjust the terms or
        cancel any Loan Application according to the Borrower’s risk status or
        business situation (including but not limited to the total size limit,
        single limit, limit per day, and limit per month) And the number of
        withdrawals.
      </div>
      <div class="list">
        4. Withholding of repayment: The Borrower and the Guarantor, may be
        require by the Lender at the point of applying for a Loan, to deposit or
        otherwise make available amounts to secure the Loan. In the event of
        default or otherwise failure of the Borrower to meet their obligations
        under this Agreement, the Lender reserves the right to collect the
        deposits made by both the Borrower and Guarantor to secure the Loan.
        Should the amount collected by the Lender not be sufficient to satisfy
        the total amount due (including penalties or interest), the Lender
        reserves the right to pursue both Borrower and Guarantor for the Loan
        amount.
      </div>
    </div>
    <div class="content">
      <div class="title">
        Article 2 Application and Information Authorization
      </div>
      <div class="list">
        1. You must personally submit a loan application to the Lender through
        the online service platform of the Lender. After passing the identity
        authentication process, you are deemed to have applied for it in person.
      </div>
      <div class="list">
        2. You should properly keep your frequently used mobile devices upto
        date (including mobile phone numbers) and other information such as
        mobile verification codes, and you should ensure that you do not
        disclose the above information to anyone. You are solely responsible for
        the losses caused by the disclosure of your account and password. If you
        find that someone has fraudulently used or stolen your account number
        and password to apply for this loan business, you should immediately
        notify the Lender in an effective manner and request the Lender to
        suspend the service. At the same time, you understand that it takes a
        reasonable period of time for the lender to act on your request. Prior
        to this, the lender will not be liable for the instructions that have
        been executed and/or the losses caused by you.
      </div>
      <div class="list">
        3. You guarantee that all the application information provided to the
        Lender is true, complete, accurate, legal and valid, and you are
        authorized to inquire or confirm the information related to your loan
        application. Should the information provided require amendment or
        otherwise require rectification prior or during the period for which you
        have procured a Loan from the Lender, you are obligated to inform the
        Lender of such rectification as soon as practically possible – this
        especially but not exclusively, applies to contact information.
      </div>
      <div class="list">
        4. The lender has the right to comprehensively decide whether to accept
        your loan application and verify your credit line based on your credit
        status, and after verifying your credit line, the lender has the right
        to rely on your credit Circumstances or identified risk control factors
        or other legitimate reasons, adjust your credit limit at any time
        (including but not limited to lowering, higher, mid-range, or final)
      </div>
      <div class="list">
        5. Your credit line approved by the lender does not constitute a credit
        commitment by the lender to you. For the specific withdrawal business
        under the credit line, you should send the loan to the lender within the
        validity period of the credit line and within the available credit line.
        When applying for a withdrawal, the lender has the right to decide
        whether to grant you a single loan under the line item and the specific
        loan amount based on your current credit and the size of the loan
        available for the loan in the current period.
      </div>
    </div>
    <div class="content">
      <div class="title">
        Article 3 Use and withdrawal of loan limit
      </div>
      <div class="list">
        1. You should ensure that this credit line is used in a safe environment
        through various media, otherwise you must be aware of the risks and
        responsible for the losses caused by using this credit line on the
        Internet or other media in a non-safe environment. Hence, the Lender
        accepts no liability for the manner and form in which you utilize the
        credit line and should the same be applied or utilized to the detriment
        of the borrower, the borrower shall still remain liable to the Lender
        for the Loan Amount.
      </div>
      <div class="list">
        2. You understand that the lender conducts identity verification for
        transactions using this amount and agrees that any successful
        transaction is its own transaction, and you bear the corresponding
        consequences of the transaction. You should ensure that you keep the
        password in a safe place and do not disclose the password to anyone, and
        you are solely responsible for the losses caused by the leakage of the
        password. Your electronically confirmed transaction vouchers, various
        settlement transactions based on passwords and other electronic data
        information, and electronic information records produced by credit line
        withdrawal and repayment exchanges are all regarded as valid vouchers
        for the transaction.
      </div>
      <div class="list">
        3. the loan personnel officer will directly issue the loan funds to your
        account according to your withdrawal application, and you will use cash
        withdrawal, transfer, payment, etc.
      </div>
      <div class="list">
        4. The loan personnel officer has the right to limit the number of
        withdrawals of the loan under this amount and the upper and lower limits
        of the withdrawal amount of a single loan.
      </div>
      <div class="list">
        5. If the Lender has repeated loans due to the Lender’s system or the
        issue of the loan channel, you irrevocably authorize the Lender to
        transfer the rebate to the repaid excess funds directly from your
        repayment account
      </div>
      <div class="list">
        6. You are not allowed to use this credit line for tax evasion, debt
        evasion, cash withdrawal, money laundering and other illegal and
        criminal activities. If you rely on the risk characteristics identified
        by its subjective judgment, the lender has the right to have or
        terminate your use of this credit line at any time without any form of
        prior notice or prior confirmation, and you are obliged to actively
        assist the lender in identifying Related risks, and bear the losses
        caused by this.
      </div>
    </div>
    <div class="content">
      <div class="title">
        Article 4 Interest rate
      </div>
      <div class="list">
        1. When you use the loan under this amount, the lender will accrue
        interest from the date the loan is successfully issued (transferred out
        from the lender) until it is paid off. The single loan interest rate
        will be set out in the process of your withdrawal. Penalties shall be
        applicable on overdue payments at a rate of 1% per day or any other
        alternate terms that the Lender may communicate in writing.
      </div>
      <div class="list">
        2. The lender has the right to modify or add new interest charging
        standards. After the standard is modified or added, it will be displayed
        on the electronic service platform provided by the lender. If you do not
        agree to modify or add new fee items or standards, you can If you stop
        applying for a new loan, the loan interest rate you previously applied
        for will not be affected.
      </div>
      <div class="list">
        3. The term of a single loan is calculated from the date the loan is
        successfully issued, and the date of issuance, due date, and repayment
        date are subject to your confirmed electronic loan debit information.
      </div>
    </div>
    <div class="content">
      <div class="title">
        Article 5 Reconciliation and repayment
      </div>
      <div class="list">
        1. You should actively check the transaction details of your account
        credit limit to confirm the transaction content. The transaction records
        under this credit line kept by the lender are all true evidence of the
        use of this line and are binding on you. The Borrower shall have no
        basis to deny the use of the quota or the transaction amount on the
        grounds that you have not received the statement or have not seen the
        transaction details.
      </div>
      <div class="list">
        2. For a single loan under this amount, all repayment methods such as
        {{ IsTest ? "monthly" : "weekly" }} installments are adopted.
      </div>
      <div class="list">
        3. You should repay the current amount of repayment before the repayment
        date of each loan, and the date of late repayment is subject to the
        electronic debit receipt confirmed by your phone during your withdrawal
        process.
      </div>
      <div class="list">
        4. The repayment method is divided into active repayment or automatic
        repayment:<br />
        4.1. You can take the initiative to repay the loan principal, interest
        and related expenses to the lender<br />
        4.2. Automatic repayment (withholding repayment): You need to deposit
        the total amount of the repayment into your repayment account one day
        before the agreed repayment date, and you irrevocably authorize the loan
        person to make your repayment The principal and interest of the loan
        under this contract and other related expenses are deducted from the
        account. You promise that the aforementioned transaction order will be
        treated as if it were made by your own person. Withholding time, amount
        and other instructions shall be subject to the Lender's notice, and the
        entire responsibility for withholding shall be borne by you and the
        lender.<br />
        4.3. You hereby confirm and authorize that when your account balance is
        insufficient, the lender has the right to reduce the withholding limit
        and issue withholding instructions through the repayment account
        multiple times.
      </div>
      <div class="list">
        5. Repayment sequence: Loan deductions are made in the order of the
        previous period, the current period and the first expense, interest, and
        the last principal. However, the lender has the right to follow your
        credit status and the loan's risk The policy sheet changes the order of
        the aforementioned deductions, without the need to notify you
        separately.
      </div>
      <div class="list">
        6. Before you have repaid all loan fees, principal and interest, you may
        not change or cancel your repayment account, except in special
        circumstances. In case of special circumstances, your repayment account
        can be changed after approval by the loan officer, but the loan function
        will be restricted.
      </div>
      <div class="list">
        7. You have the right to apply for early settlement. When there are
        multiple outstanding loans, the lender has the right to limit the order
        of the IOUs settled in advance and the lower limit of the amount. The
        specific result of the final review after the loan officer accepts your
        early repayment application shall prevail. Loans are exempt from early
        repayment defaults.
      </div>
      <div class="list">
        8. This contract is unique, and your repayment and other related
        responsibilities under this contract are all independent
        responsibilities: the rights and obligations under this contract will
        not be changed due to any disputes between you and the transaction
        partner or any other disputes. Medium, final, and ineffective.
      </div>
    </div>
    <div class="content">
      <div class="title">
        Article 6 Contract modification, contact and transfer
      </div>
      <div class="list">
        1. The Lender reserves the right to introduce new provisions or amend
        pre-existing terms and conditions that affect directly or indirectly the
        terms of this Loan and shall undertake to notify the borrower of the
        same with at least seven (7) days’ notice. Should the Borrower not wish
        to proceed under the new terms, they shall be required to settle all
        outstanding dues as at the date of the change in terms and conditions,
        and immediately cease to utilize the service offered by the Lender.
      </div>
      <div class="list">
        2. After this contract becomes effective, unless otherwise agreed in
        this contract, you are not allowed to change or terminate this contract
        without authorization. The lender has the right to suspend or terminate
        this contract or any part of it at any time based on its own business
        considerations and require you to repay the amount payable under this
        contract within a specified time limit.
      </div>
      <div class="list">
        3. The lender has the right to transfer all or part of its rights and
        obligations under this contract to a third party, and the transfer does
        not require your consent. You understand and agree that such transfers
        do not require notification to you.
      </div>
    </div>
    <div class="content">
      <div class="title">
        Article 7 Breach of contract
      </div>
      <div class="list">
        1. Any of the following events constitutes an event of default as
        referred to in this clause<br />
        1.1 Your delay in the settlement of the principal or interest and
        expenses for a period of time, beyond what had been stipulated in the
        Loan Terms.<br />
        1.2 Your failure to perform any of the obligations under this
        contract<br />
        1.3 Your provisions of any false information to the lender
      </div>
      <div class="list">
        2. When a breach of contract occurs, the lender has the right to take
        the following measures<br />
        2.1 You are required to pay back all the loan principals and settle the
        interest in advance<br />
        2.2 Adjust the loan amount, term and interest rate according to the loan
        risk status<br />
        2.3 Announce that your outstanding loan under this contract is due in
        advance, and the corresponding amount will be deducted from your
        repayment account to recover related expenses, penalty interest,
        compound interest, loan principal and interest, or recover your payables
        in a legal manner<br />
        2.4 Take other measures required by laws and regulations
      </div>
      <div class="list">
        3. Any failure to repay the principal and interest of the loan in a
        timely manner is deemed to be overdue. From the date of overdue, the
        overdue loan amount will be charged at the interest rate agreed in the
        loan note under this contract, and the penalty interest will be
        collected until the overdue principal and interest are paid off.
      </div>
      <div class="list">
        4. All the expenses (including but not limited to notary fees,
        litigation fees, lawyer fees, and travel expenses) of the loan due to
        collection of money from you and the realization of creditor's rights
        shall be borne by you.
      </div>
      <div class="list">
        5. The loan software (hardware) system fails to operate normally due to
        any of the following conditions in the loan software (hardware) system,
        which makes it impossible to provide you with this service. The Lender
        shall not be liable for any breach of contract or compensation,
        including but not limited to<br />
        5.1 During the maintenance period of this service site<br />
        5.2 The telecommunications equipment fails to transmit data<br />
        5.3 Due to irresistible factors such as station, earthquake, tsunami,
        flood, power outage, war, terrorist attack, etc., the service operation
        system is obstructed and the business cannot be performed <br />
        5.4 Due to customer attacks, the Communicaion Authority of Kenya, the
        opening of repayment accounts, and other third-party payment
        organizations that have information technology-dependent departments,
        technical adjustments or failures of enterprises and institutions,
        website upgrades, etc.
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    IsTest: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.IsTest);
  },
};
</script>
<style lang="scss" scoped>
@import url("../assets/css/index.css");
.con {
  .content {
    margin-bottom: 20px;
    .title {
      font-family: "rb";
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      z-index: 2;
      font-size: 16px;
      margin-bottom: 20px;
    }
    .list {
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 10px;
      position: relative;
      color: #333333;
      font-family: "rr";
    }
  }
}
</style>
